var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-node.js
// module id = 109
// module chunks = 0 1